

import ReactGA from "react-ga4";

// Initialize Google Analytics with the Measurement ID
export const initGA = () => {
  ReactGA.initialize("G-Z0V1K1JBV6"); // Replace with your Google Analytics Measurement ID
};

// Function to log a pageview hit
export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
};
